import UserControlsBar from './UserControlsBar'

export { UserControlsBar }
export default UserControlsBar
